import React, { Fragment } from 'react';
import { getAnchorId } from '@/helpers/utils';
import Partner from './Partner';
import { Profile } from '../interface';
import Divider from '../../common/Divider';

interface PartnerProfilesProps {
  partners: Profile[];
  showMobileView?: boolean;
}

const PartnerProfiles: React.FC<PartnerProfilesProps> = ({
  partners,
  showMobileView = false,
}) => (
  <>
    {partners.map((partner, idx) => {
      const anchorId = getAnchorId({
        type: 'partner',
        name: partner.name,
        title: undefined,
        idx,
        section: partner.header,
      });
      return (
        <Fragment key={partner.name}>
          <h2 className="margin-3-b color-text-emphasis tw-col-span-6 tw-col-start-2 tw-font-sans tw-text-2xl">
            {partner.header}
          </h2>
          <Partner
            partner={partner}
            anchorId={anchorId}
            trackingRole={partner.header}
            showMobileView={showMobileView}
          />
          <Divider />
        </Fragment>
      );
    })}
  </>
);

export default PartnerProfiles;
